import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10769_88379)">
      <path
        d="M14 11.0833C14 12.0482 13.2148 12.8333 12.25 12.8333V13.4167C12.25 13.7392 11.9892 14 11.6667 14C11.3441 14 11.0833 13.7392 11.0833 13.4167V12.8333H10.927C10.3046 12.8333 9.72358 12.4985 9.4115 11.9589C9.24992 11.6795 9.34558 11.3231 9.62383 11.1621C9.90325 10.9993 10.2603 11.0962 10.4207 11.3744C10.5251 11.5553 10.7188 11.6667 10.9264 11.6667H12.2494C12.5714 11.6667 12.8328 11.4053 12.8328 11.0833C12.8328 10.8622 12.6747 10.6762 12.4565 10.6394L10.6832 10.3442C9.90033 10.2136 9.33275 9.54275 9.33275 8.75C9.33275 7.78517 10.1179 7 11.0828 7V6.41667C11.0828 6.09408 11.3435 5.83333 11.6661 5.83333C11.9887 5.83333 12.2494 6.09408 12.2494 6.41667V7H12.4057C13.0282 7 13.6092 7.33483 13.9212 7.87442C14.0828 8.15383 13.9872 8.51025 13.7089 8.67125C13.4289 8.83342 13.0725 8.73658 12.9121 8.45892C12.8077 8.27808 12.614 8.16667 12.4063 8.16667H11.0833C10.7613 8.16667 10.5 8.428 10.5 8.75C10.5 8.97108 10.6581 9.15717 10.8763 9.19392L12.6496 9.48908C13.4324 9.61975 14 10.2906 14 11.0833ZM11.0833 1.16667H10.5V0.583333C10.5 0.26075 10.2392 0 9.91667 0C9.59408 0 9.33333 0.26075 9.33333 0.583333V1.16667H4.66667V0.583333C4.66667 0.26075 4.40592 0 4.08333 0C3.76075 0 3.5 0.26075 3.5 0.583333V1.16667H2.91667C1.30842 1.16667 0 2.47508 0 4.08333V11.0833C0 12.6916 1.30842 14 2.91667 14H8.16667C8.48925 14 8.75 13.7392 8.75 13.4167C8.75 13.0941 8.48925 12.8333 8.16667 12.8333H2.91667C1.95183 12.8333 1.16667 12.0482 1.16667 11.0833V5.83333H9.91667C10.2392 5.83333 10.5 5.57258 10.5 5.25C10.5 4.92742 10.2392 4.66667 9.91667 4.66667H1.16667V4.08333C1.16667 3.1185 1.95183 2.33333 2.91667 2.33333H11.0833C12.0482 2.33333 12.8333 3.1185 12.8333 4.08333V5.25C12.8333 5.57258 13.0941 5.83333 13.4167 5.83333C13.7392 5.83333 14 5.57258 14 5.25V4.08333C14 2.47508 12.6916 1.16667 11.0833 1.16667Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_10769_88379">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const IconHourlyRates = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default IconHourlyRates;
